/*require('./../../../style/input-plugin/emotion.less');*/
var $ = require('jQuery');
var Plugin = require('./Plugin');
var template = require('./../../../template/input-plugin/emotion-1.html');
var EmotionHandler = require('./../../../../lib/EmotionHandler');
var gdic = require('./../../../global/globalDic');
var utils = require('./../../../global/utils')

var Emotion = function (options) {
    this._opened = false;

    (function (self) {
        var defaults = {
            template: template
        };
        $.extend(defaults, options);
        Plugin.call(self, defaults);

        self._element.find('.im-emotion-icon').click(function () {
            //self._input._options.editor.richBlur();
            if (self._opened)
                self.close();
            else
                self.open();
                //埋点统计（表情按钮点击）
                if(window.WMDA_REPORT){
                    window.WMDA_REPORT('custom',{event_id:'26'})
                }
        });
        
        var eleEmotionListIcon = self._element.find('.im-emotion-list').find('.im-emotion-unit').parent('a').parent('li');
        eleEmotionListIcon.click(function (e) {
            e.preventDefault();
            var emotionId = parseInt($(this).children('a').attr('data-emotionid'));
            var emotionTitle = '[' + EmotionHandler.getEmotionTitles(emotionId) + ']';
            var emotionDiv;
            //表情转换
            if (self._input._options.editor._element[0].tagName == 'DIV') {
                // emotionDiv = '<img src = "http://img.58cdn.com.cn/webim/v7/emotions/'+emotionId+'.png" data="' + emotionTitle + '" style="margin-bottom:-3px;margin-left:5px;display:inline-block;width:24px;height:24px;">'
                emotionDiv = '<img src = "http://static.58.com/git/teg-app-fe/im-images/xcx-images/emotions@2x/'+emotionId+'.png" data="' + emotionTitle + '" style="margin-bottom:-3px;margin-left:5px;display:inline-block;width:24px;height:24px;">'
            } else {
                emotionDiv = emotionTitle;
            }
            //self._input._options.editor.getElement().find("br").last().remove();
            var userAgent = navigator.userAgent;
            if (userAgent.indexOf("Firefox") > -1) { //判断是否Firefox浏览器
                //document.execCommand('insertHTML', false, emotionDiv)
                self._input._options.editor.update(emotionDiv, {
                    is_emotion: true
                });
            }else{
                var curRange = gdic.get('curRange')      
                utils.getInsertEmojiCursor(emotionDiv,curRange);
            }     
            self.close();
            self._input.showSend();
            //self._input._options.editor.focus();
        });

        /*eleEmotionListIcon.mouseover(function (e) {
         e.preventDefault();
         var emotionId = parseInt($(this).parent('a').attr('data-emotionid'));
         self.emotionDefault().show(emotionId);
         });*/

        //翻页显示
        var eleEmotionPage = self._element.find('.im-emotion-footer').find('.im-emotion-arrow').find('a');
        var page = self._element.find('.im-emotion-list')
        var currentPage = 1;
        var prePage = 1;
        var maxPage = 3
        eleEmotionPage.click(function (e) {
            e.preventDefault();
            var move = e.target.className.indexOf('im-right-arrow') !== -1 ? 'right' : 'left'
            currentPage = move === 'right' ? prePage + 1 : prePage - 1;
            if (currentPage > maxPage || currentPage < 1) {
                currentPage = prePage
                return;
            }
            $('.im-emotion-page.page' + prePage).hide()//上一页隐藏
            $('.im-emotion-page.page' + currentPage).show()//当前页显示
            
            if (currentPage == maxPage) {
                $(this).removeClass('im-right-arrow').addClass('im-right-arrow-no').prev().removeClass('im-left-arrow-no').addClass('im-left-arrow');
            }
            if(currentPage < maxPage && currentPage > 1){
                if (move === 'right') {
                    $(this).prev().removeClass('im-left-arrow-no').addClass('im-left-arrow')
                } else {
                    $(this).next().removeClass('im-right-arrow-no').addClass('im-right-arrow')
                }
            }
            if (currentPage == 1) {
                $(this).removeClass('im-left-arrow').addClass('im-left-arrow-no').next().removeClass('im-right-arrow-no').addClass('im-right-arrow');
            }
            prePage = currentPage
        });

        $(self._win).click(function (e) {
            var contains = $.contains(self._element[0], e.target);
            if (self._opened && !contains)
                self.close();
        });
    })(this);
};
Emotion.prototype = Object.create(Plugin.prototype);

module.exports = Emotion;
